import { response } from "app/helpers/commonInterface";
import {
  GET_CLIENT_LIST_FAILURE,
  GET_CLIENT_LIST_REQUEST,
  GET_CLIENT_LIST_SUCCESS,
  UPDATE_CLIENT_STATUS_SUCCESS,
} from "../actionTypes";
import { updateStatusFun } from "../stateHelperFunction";
import { client } from "./clientDataInterfce";
export interface clientListState {
  loading: boolean;
  clientList: response<client[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: clientListState = {
  loading: false,
  clientList: {},
  error: "",
};

export const clientListReducer = (state = initialState, action: action) => {
  switch (action.type) {
    case GET_CLIENT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_CLIENT_LIST_SUCCESS:
      return {
        loading: false,
        clientList: action.payload,
        error: "",
      };
    case GET_CLIENT_LIST_FAILURE:
      return {
        loading: false,
        clientList: {},
        error: action.payload,
      };
    case UPDATE_CLIENT_STATUS_SUCCESS:
      return updateStatusFun(
        state,
        "clientList",
        action.payload.data.records.Id
      );
    default:
      return state;
  }
};
